import IssuuLookupResourceModel from '../../generated/types/model/resource/IssuuLookupResourceModel';

export default class IssuuLookupResourceViewModel extends IssuuLookupResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
